import React from "react";
import "./Tabs.scss";
import Dropdown from "../Dropdown/Dropdown";

interface Tab {
  id: string;
  label: string;
  content: any;
}

interface IProps {
  tabs: Tab[];
  type: "tab" | "select" | "dropdown";
  labelText?: string;
  position?: "left" | "right" | "center" | "full-width";
}

const Tabs: React.FC<IProps> = (props: IProps) => {
  const [activeTab, setActiveTab] = React.useState<string>(props.tabs[0].id);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setActiveTab(event.target.value);
  };

  const getTabsClass = () => {
    switch (props.position) {
      case "left":
        return "justify-content-start";
      case "right":
        return "justify-content-end";
      case "center":
        return "justify-content-center";
      case "full-width":
        return "nav-fill";
      default:
        return "";
    }
  };

  const renderTabContent = (content: any) => {
    if (typeof content === "string") {
      return content;
    }
    if (Array.isArray(content)) {
      return content.map((componentObj, index) => {
        const { component: Component, props } = componentObj;
        return <Component key={index} {...props} />;
      });
    }
    return null;
  };

  return (
    <>
      {props.type === "tab" ? (
        <ul
          className={`nav nav-tabs border-0 ${getTabsClass()}`}
          id="myTab"
          role="tablist"
        >
          {props.tabs.map((tab) => (
            <li className="nav-item" key={tab.id}>
              <button
                className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                id={`${tab.id}-tab`}
                type="button"
                role="tab"
                aria-controls={tab.id}
                aria-selected={activeTab === tab.id}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <div className={`nav ${getTabsClass()}`}>
          <div className="input-group mb-3">
            {props.labelText && (
              <div className="input-group-prepend w-100 w-md-auto">
                <label
                  className="input-group-text bg-client-blue text-white w-100 d-grid text-center"
                  htmlFor="dropdownFC"
                >
                  {props.labelText}
                </label>
              </div>
            )}
            {props.type === "select" ? (
              <select
                className="custom-select custom-select-lg"
                value={activeTab}
                onChange={handleSelectChange}
              >
                {props.tabs.map((tab) => (
                  <option value={tab.id} key={tab.id}>
                    {tab.label}
                  </option>
                ))}
              </select>
            ) : (
              <Dropdown
                id="dropdownFC"
                options={props.tabs.map((tab) => ({
                  id: tab.id,
                  label: tab.label,
                }))}
                fullWidth={true}
                selectedOption={activeTab}
                onSelect={handleTabClick}
              />
            )}
          </div>
        </div>
      )}
      <div className="tab-content" id="myTabContent">
        {props.tabs.map((tab) => (
          <div
            className={`tab-pane fade ${
              activeTab === tab.id ? "show active" : ""
            }`}
            id={tab.id}
            role="tabpanel"
            aria-labelledby={`${tab.id}-tab`}
            key={tab.id}
          >
            {renderTabContent(tab.content)}
          </div>
        ))}
      </div>
    </>
  );
};

export default Tabs;
